const dayReducer = (day = 'unset', action) => {
    switch(action.type){
        case 'CHANGE_DAY':
            return action.data;
        default:
            return day;
    }
}

export default dayReducer;